export const AUTH_TOKEN = 'auth_token'
export const USER_ID = 'user_id'
export const COMPANY_NAME = 'company_name'
export const COMPANY_LOGO= 'company_logo_url'
export const APP_ID = 1793642705